import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/element-overrides.css'
import router from './router'
import { jumpToMiniApp } from '@/config'
import { eventBus } from '@/utils/eventBus'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.prototype.$Element = {size: 'small',zIndex: 3000}

// 全局小程序跳转方法
Vue.prototype.$showMiniProgram = function() {
  jumpToMiniApp(() => eventBus.$emit('show-mini-program'))
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')